import React, { useEffect, useState } from "react";
import CreateSupportRequestModal from "./modals/CreateSupportRequestModal";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import { useAuthContext } from "../../hooks/useAuthContext";
import "./HelpAndSupport.css";
import SideMenu from "../../components/SideMenu";
import { useNavigate } from "react-router-dom";
import HelpAndSupportContainer from "./HelpAndSupportContainer";

export default function HelpAndSupport() {
  const [supportRequests, setSupportRequests] = useState([]);
  const [createRequestModal, setCreateRequestModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navi = useNavigate();
  const { user,dispatch } = useAuthContext();

  const cancelModal = () => {
    setCreateRequestModal(false);
  };

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const supportRequestResponse = await axios.get(
        `${ApiConnectionString}/api/SupportRequests`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (supportRequestResponse.status == 200) {
        setSupportRequests(supportRequestResponse.data);
      }
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching support requests:", error);
      // Handle the error as needed, e.g., show an error message to the user
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [createRequestModal,user]);
  if (isLoading) {
    return <LoadingSpinner />;
  } else {
    return (
      <div className="">

        <div className="hsBigScreen">
        <div className="row">
          <div className="col-3 side-menu-container">
            <SideMenu />
          </div>
          <div className="col">
            <HelpAndSupportContainer />
          </div>
        </div>
        </div>
        <div className="hsSmallScreen">
        <HelpAndSupportContainer />
          </div>
     

        {createRequestModal && (
          <CreateSupportRequestModal cancelModal={cancelModal} />
        )}
      </div>
    );
  }
}
